import { Link } from 'react-router-dom'

/**
 * Заголовок страницы с заголовком, подзаголовком, бейджем и действиями.
 * Единый паттерн: заголовок + бейдж на одной строке, ссылка «Назад» справа.
 * Используется на страницах: Модели, Фаны, Чаты, Конфигурация (список и редактирование).
 */
export default function PageHeader({ title, subtitle, badge, backHref, backLabel, children, className = '' }) {
  return (
    <div className={`page-header ${className}`.trim()}>
      <div className="page-header-left">
        {(title || badge) && (
          <div className="page-header-title-row">
            {title && <h1 className="page-title">{title}</h1>}
            {badge && <span className="page-header-badge">{badge}</span>}
          </div>
        )}
        {subtitle && <p className="page-subtitle">{subtitle}</p>}
      </div>
      {(backHref || children) && (
        <div className="page-header-right">
          {backHref && (
            <Link to={backHref} className="page-header-back">
              {backLabel || '← К списку'}
            </Link>
          )}
          {children}
        </div>
      )}
    </div>
  )
}
